export default __webpack_public_path__ + "static/assets/med_pill_rectangle_in_L0_solid_x_01_f.e6887b97.png";